import _ from 'lodash';

export const calculateGradient = (colorLib) => {
  const xMin = 0;
  const xMax = 100;
  const yMin = colorLib['fill-color'].stops[0][0];
  const yMax =
    colorLib['fill-color'].stops[colorLib['fill-color'].stops.length - 1][0] >= 800 ?
    colorLib['fill-color'].stops[colorLib['fill-color'].stops.length - 2][0] :
    colorLib['fill-color'].stops[colorLib['fill-color'].stops.length - 1][0];
  const gradient = [];
  colorLib['fill-color'].stops.map(stop => {
    const inputY = stop[0];
    const percent = (inputY - yMin) / (yMax - yMin);
    const outputX = percent * (xMax - xMin) + xMin;
    gradient.push(`${stop[1]} ${outputX}%`);
  });
  return gradient;
};

export const calculateValue = (colorLib, position, xMax) => {
  const xMin = 0;
  const yMin = colorLib['fill-color'].stops[0][0];
  const yMax =
    colorLib['fill-color'].stops[colorLib['fill-color'].stops.length - 1][0] >= 800 ?
    colorLib['fill-color'].stops[colorLib['fill-color'].stops.length - 2][0] :
    colorLib['fill-color'].stops[colorLib['fill-color'].stops.length - 1][0];
  return ((position - xMin) / (xMax - xMin)) * (yMax - yMin) + yMin;
};

export const colorCalculate = (colorLib, metadata) => {
  const stops = colorLib['fill-color'].stops;
  return _.find(stops, (val) => {
    return val[0] == (
      stops.map(stop => stop[0])
    ).reduce((prev, curr) => {
      return (Math.abs(curr - metadata.value) < Math.abs(prev - metadata.value) ? curr : prev)
    });
  });
};